import { useEffect, useState } from 'react'
import { listPlatforms } from '@/lib/api'
import type { Platform } from '@/types'
import { CardGrid, Card } from '@/components/ui/Card'
import { StatusDot } from '@/components/ui/StatusDot'
import { PendingBackendNotice } from '@/components/ui/EmptyState'

export function Platforms() {
  const [platforms, setPlatforms] = useState<Platform[]>([])

  useEffect(() => {
    listPlatforms().then(setPlatforms)
  }, [])

  return (
    <div>
      <PendingBackendNotice endpoint="GET /platforms" />
      <h1 style={{ fontSize: 20, fontWeight: 500, marginBottom: 4 }}>Plataformas</h1>
      <p style={{ fontSize: 13, color: 'var(--text-secondary)', marginBottom: 20 }}>
        Infraestructura donde corren los agentes — visibilidad, no configuración de agente.
      </p>
      <CardGrid>
        {platforms.map((p) => (
          <Card key={p.id}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6 }}>
              <div style={{ fontSize: 14, fontWeight: 500 }}>{p.name}</div>
              <StatusDot status={p.status} showLabel={false} />
            </div>
            <p style={{ fontSize: 13, color: 'var(--text-secondary)' }}>{p.description}</p>
          </Card>
        ))}
      </CardGrid>
    </div>
  )
}
